import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { Site } from 'src/app/model/site';
import { AppState } from 'src/app/store/app.reducer';
import { selectCurrentSite } from 'src/app/store/site/site.selector';

@Component({
	selector: 'app-site-common-alerts',
	templateUrl: './site-common-alerts.component.html'
})
export class SiteCommonAlertsComponent implements OnInit, OnDestroy {
	@Input() originComponent: string;

	currentSite$: Observable<Site | undefined>;
	currentSiteSub: Subscription | undefined;

	currentSite: Site | undefined;

	constructor(
		private store: Store<AppState>
	) {
		this.initSelectors();
	}

	ngOnInit(): void {
		this.subscribeAll();
	}

	initSelectors(): void {
		this.currentSite$ = this.store.select(selectCurrentSite);
	}

	subscribeAll(): void {
		this.currentSiteSub = this.currentSite$.subscribe((currentSite) => {
			this.currentSite = currentSite;
		});
	}

	ngOnDestroy(): void {
		this.currentSiteSub?.unsubscribe();
	}

	timezoneNotSet(): boolean {
		if (this.currentSite && (this.currentSite.Timezone === undefined || this.currentSite.Timezone === null || this.currentSite.Timezone === '')) {
			return true;
		}
		return false;
	}
}
